<template>
    <div class="inputSelect">
        <div class="button"
             @click.stop="showPopup = !showPopup">
            <login-input
                    class="input"
                    v-model="inputVal"
                    :placeholder="placeholder"
                    readonly
                    :trailingIcon="trailingIcon"
            ></login-input>
        </div>
        <div v-if="showPopup" class="inputSelectPopup" :class="{isMobileContainer: isMobile}" @click.stop="hidePopup">
            <div id="inputSelectPopup_content" class="inputSelectPopup_content">
                <ul>
                    <li class="inputSelectPopup_item" v-for="(item, index) in selectArray" @click.stop="setCurrentItem(index)">
                        <p v-html="item.title"></p>
                    </li>
                </ul>
            </div>
        </div>
    </div>

</template>

<script>
    import LoginInput from "./login-input";
    export default {
        name: "login-input-select",
        components: {LoginInput},
        props: {
            selectArray: Array,
            placeholder: String,
            defaultCurrentIndex: {type: Number, default: -1},
        },
        data() {
            return {
                showPopup: false,
                inputVal: this.defaultCurrentIndex >= 0 ? this.selectArray[this.defaultCurrentIndex].title : '',
                currentItem: this.defaultCurrentIndex >= 0 ? this.selectArray[this.defaultCurrentIndex] : null,
                isMobile: false,
            }
        },
        mounted: function () {
            this.isMobile = window.innerWidth < 600;
            if (!this.isMobile) {
                // Event
                window.addEventListener('click', (e) => {
                    if (!this.$el.contains(e.target)) {
                        this.showPopup = false
                    }
                });
            }
        },
        computed: {
            currentItemData: function () {
                if (this.selectArray && this.selectArray[this.currentItem])
                    return this.selectArray[this.currentItem];
                else
                    return {logo: '', name: '', maskPlaceholder: '',}
            },
            trailingIcon: function () {
                return this.showPopup ? '<svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<path d="M7.28995 3.29L4.69995 0.7C4.30995 0.31 3.67995 0.31 3.28995 0.699999L0.699948 3.29C0.0699483 3.92 0.519948 5 1.40995 5L6.58995 5C7.47995 5 7.91995 3.92 7.28995 3.29Z" fill="black" fill-opacity="0.54"/>\n' +
                    '</svg>' : '<svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<path d="M0.710051 1.71L3.30005 4.3C3.69005 4.69 4.32005 4.69 4.71005 4.3L7.30005 1.71C7.93005 1.08 7.48005 0 6.59005 0H1.41005C0.520051 0 0.0800515 1.08 0.710051 1.71Z" fill="black" fill-opacity="0.54"/>\n' +
                    '</svg>';
            }
        },
        methods: {
            setCurrentItem: function (index) {
                this.currentItem = index;
                this.inputVal = this.selectArray[this.currentItem].title;
                this.showPopup = false;
                this.$emit('setItem', this.selectArray[this.currentItem])
            },
            hidePopup: function (e) {
                if (!this.el)
                    this.el = document.getElementById('inputSelectPopup_content');
                if (this.el && this.el.contains(e.target)) {
                    this.showPopup = false;
                }
            }
        },
    }
</script>

<style lang="scss">
    .rightContent .inputSelect {
        height: 54px;
        margin-top: 34px;
        position: relative;
    }
    .inputSelect {
        height: 46px;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        .loginInput .trailingIcon {
            top: 11px;
            width: 20px;
        }
        p {
            font-weight: 500;
            font-size: 16px;
            line-height: 24px;
        }
        .input {
            margin: 0;
        }
        .button {
            width: 100%;
            margin-top: 34px;
            margin-bottom: 32px;
        }
        .inputSelectPopup {
            position: absolute;
            top: 54px;
            left: 0;
            width: 100%;
            color: rgba(0, 0, 0, 0.87);
            z-index: 10;
            &_content {
                background: #FFFFFF;
                box-shadow: 0 1px 8px rgba(0, 0, 0, 0.2), 0 3px 3px rgba(0, 0, 0, 0.12), 0 3px 4px rgba(0, 0, 0, 0.14);
                border-radius: 8px;
                padding: 8px 0;
                ul {
                    margin: 0;
                    padding: 0;
                    overflow: auto;
                    max-height: 35vh;
                }
                li { list-style-type: none; }
            }
            &_item {
                cursor: pointer;
                text-align: left;
                padding: 0 18px;
                p {
                    margin: 0;
                    padding: 10px 0;
                }
                &:hover {
                    background: #E1F4F0;
                }
            }
        }
        .isMobileContainer {
            position: fixed;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background: rgba(0,0,0,.6);
            .inputSelectPopup_content {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 328px;
                background: #fff;
            }
        }
    }
    @media (min-width: 751px) {
        .inputSelect .loginInput .trailingIcon {
            top: 15px;
            right: 16px;
        }
    }
</style>